import type { FunctionComponent } from 'react'
import React from 'react'
// import { useLocation } from 'react-router-dom'
import { Author } from '@which/seatbelt'

import classnames from 'classnames'

import type { ReviewsAdviceSingleArticleData } from '../../ReviewsAdviceSinglePage'
import styles from './AuthorWrapper.module.scss'

type AuthorWrapperProps = {
  authors: ReviewsAdviceSingleArticleData['authors']
  withAuthorLink?: boolean
}

export const AuthorWrapper: FunctionComponent<AuthorWrapperProps> = ({
  authors = [],
  withAuthorLink = false,
}) => (
  <div
    className={classnames(styles.authorWrapper, authors?.length > 1 && styles.authorWrapperGrid)}
  >
    {authors.map(({ jobTitle, name, image, slug, about }, index) => {
      const cleanSlug = slug?.replace(/\?/g, '').replace(/ /g, '-').toLowerCase()
      const includeAuthorLink = cleanSlug && withAuthorLink && name !== 'Which?'

      return (
        <Author
          key={`${name}${index}`}
          jobTitle={jobTitle}
          name={name}
          src={image?.src}
          sources={image?.sources}
          {...(includeAuthorLink && {
            href: `/author/${cleanSlug}`,
          })}
          {...(authors.length < 3 && {
            about,
          })}
          className={styles.authorWrapperAuthor}
        />
      )
    })}
  </div>
)
